import { createFileRoute, Navigate } from '@tanstack/react-router';
import { QuestionLabelsTable } from '@/components/QuestionLabelsTable/QuestionLabelsTable';
import { CreatorGuard } from '@/components/CreatorGuard/CreatorGuard';
import PageNotFound from '@/components/Error/PageNotFound/PageNotFound';
import { FeatureFlagGuard } from '@/components/FeatureFlagGuard/FeatureFlagGuard';
import { FEATURE_FLAGS } from '@/config/features';

export const Route = createFileRoute('/dashboard/_primary-routes/question-labels')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <FeatureFlagGuard
      flag={FEATURE_FLAGS.LABEL_MANAGEMENT}
      redirect={
        <Navigate
          to="/dashboard/data-source/$tab"
          params={{ tab: 'datasets' }}
          replace
        />
      }
    >
      <CreatorGuard fallback={<PageNotFound />}>
        <div className="flex h-[calc(100vh-110px)] flex-col bg-white">
          <div className="flex flex-col gap-2 border-b border-gray-200 bg-white px-8 py-5">
            <h3 className="text-xl font-semibold">Question Labels</h3>
            <p className="text-foreground-800 text-base">
              On this page, you can view and manage the list of question label suggestions which will appear for anyone
              in your organization. Edits will apply to the suggestions, not to existing question labels.
            </p>
          </div>
          <div className="min-h-0 flex-1 p-5 pb-10">
            <QuestionLabelsTable />
          </div>
        </div>
      </CreatorGuard>
    </FeatureFlagGuard>
  );
}
